<template>
  <div class="balance">
    <div class="balance__title">Отгрузки</div>
    <BaseBtn
      @btnClick="updatePopup(true, 'PopupProfileBalance')"
      text="Запросить список отгрузок"
      class="balance__add"
    />
    <div v-if="profileShippings && !isMobile" class="balance__item balance__item--title">
      <div class="balance__panel" :class="{ item: !hasDealerContractors }">
        <div class="balance__number">№</div>
        <div class="balance__date">Дата запроса</div>
        <div v-if="hasDealerContractors" class="balance__contractor">Контрагент</div>
        <div class="balance__employee">Сотрудник</div>
        <div class="balance__period">Период</div>
        <div class="balance__status">Статус</div>
      </div>
    </div>
    <ul v-if="profileShippings" class="balance__list">
      <li v-for="(item, index) in profileShippings" :key="index" class="balance__item">
        <MobileTitle
          v-if="isMobile"
          @toggleSection="toggleSection(item.id)"
          :modif="'balance'"
          :class="[{ active: section === item.id }, 'balance__section']"
        >
          <div class="balance__group">
            <div class="balance__number">{{ index + 1 }}.</div>
            <div class="balance__info">
              <template v-if="item.created_at || item.employee_name">
                {{ item.created_at }}
                <span>{{ item.employee_name }}</span>
              </template>
              <template v-else>Подробнее</template>
            </div>
          </div>
        </MobileTitle>

        <div
          :class="[{ active: section === item.id, item: !hasDealerContractors }, 'balance__panel']"
        >
          <div v-if="!isMobile" class="balance__number">
            {{ index + 1 }}
          </div>
          <div class="balance__date">
            <span v-if="isMobile">Дата запроса:</span>
            {{ item.created_at ? item.created_at : '-' }}
          </div>
          <div v-if="hasDealerContractors" class="balance__contractor">
            <span v-if="isMobile">Контрагент:</span>
            {{ item.contractor_name }}
          </div>
          <div class="balance__employee">
            <span v-if="isMobile">Сотрудник:</span>
            {{ item.employee_name ? item.employee_name : '-' }}
          </div>
          <div class="balance__period">
            <span v-if="isMobile">Период:</span>
            {{ item.date_from && item.date_to ? `${item.date_from} - ${item.date_to}` : '-' }}
          </div>
          <div class="balance__status">
            <span v-if="isMobile">Статус:</span>
            <template v-if="item.updated_at">
              Список отгрузок отправлен {{ item.updated_at }}
              <template v-if="item.email.length">на email</template>
              <div>
                <a
                  v-for="(email, indexEmail) in item.email"
                  :key="indexEmail"
                  :href="`mailto:${email}`"
                >
                  {{ email
                  }}<span v-if="item.email.length > 1 && indexEmail + 1 !== item.email.length"
                    >,
                  </span>
                </a>
              </div>
            </template>
            <template v-else>В обработке</template>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'Shippings',
  components: {
    BaseBtn: () => import('@/components/base/BaseBtn'),
    MobileTitle: () => import('@/pages/account/components/MobileTitle'),
  },
  metaInfo() {
    return {
      title: `Отгрузки - Личный кабинет дилера - ${this.getDealerName}`,
    };
  },
  computed: {
    ...mapState({
      profileShippings: state => state.account.profileShippings,
    }),

    ...mapGetters('user', ['getDealerName', 'hasDealerContractors']),
  },
  methods: {
    ...mapActions('account', ['setProfileShippings']),
  },
  created() {
    this.setProfileShippings();
  },
};
</script>

<style lang="scss" scoped>
.item {
  div {
    width: calc(25% - 110px / 4);

    &:first-child {
      width: 110px;
    }

    &:last-child {
      width: 15%;
    }
  }
}

.balance {
  padding-bottom: 30px;

  @media (max-width: $desktop) {
    display: flex;
    flex-direction: column;
  }

  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    position: fixed;
    z-index: 120;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 53px;
    margin: 0;

    @media (max-width: $desktop) {
      position: static;
      height: auto;
      transform: translateX(0);
      margin-bottom: 26px;
      order: 1;
      z-index: 1;
    }
  }

  &__list {
    @media (max-width: $desktop) {
      order: 3;
    }
  }

  &__item {
    &:nth-child(even) {
      background-color: #f3f3f3;

      @media (max-width: $desktop) {
        background-color: transparent;

        .balance__section {
          background-color: #f3f3f3;
        }
      }
    }

    &--title {
      color: #979797;
      font-size: 14px;
      line-height: 14px;
      border-bottom: 2px solid #dee2e6;
    }
  }

  &__panel {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;

    @media (max-width: $desktop) {
      width: 100vw;
      margin: 0 -20px;
      padding: 20px 20px 16px;
      background: #f3f3f3;
      box-shadow: inset 0px 4px 30px rgba(65, 68, 71, 0.3);
      display: none;

      &.active {
        display: block;
      }
    }
  }

  &__group {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    font-size: 14px;
    line-height: 18px;
    font-weight: normal;
    flex: 1;
    text-align: left;

    span {
      display: block;
      font-weight: bold;
    }
  }

  &__info {
    flex: 1;
  }

  &__number {
    width: 70px;
    flex-shrink: 0;
    text-align: center;

    @media (max-width: $desktop) {
      width: 23px;
      text-align: left;
    }
  }

  &__employee {
    width: 18%;
    margin-right: 10px;
  }

  &__date {
    width: 18%;
    margin-right: 10px;
  }

  &__contractor {
    width: 18%;
    margin-right: 10px;
  }

  &__period {
    width: 21%;
    margin-right: 10px;
  }

  &__status {
    width: 15%;

    a {
      color: #39aee3;
      text-decoration: none;
    }
  }

  &__employee,
  &__date,
  &__period,
  &__contractor,
  &__status {
    @media (max-width: $desktop) {
      font-size: 14px;
      line-height: 18px;
      font-weight: bold;
      margin-bottom: 4px;
      width: 100%;
      text-align: left;

      span {
        display: block;
        margin-bottom: 2px;
        font-size: 14px;
        line-height: 18px;
        font-weight: normal;
        color: #979797;
      }
    }
  }

  &__add {
    margin-bottom: 30px;

    @media (max-width: $desktop) {
      order: 2;
      margin-bottom: 26px;
    }
  }
}
</style>
